import { render, staticRenderFns } from "./UserCardContent.vue?vue&type=template&id=5baf2b02&"
import script from "./UserCardContent.vue?vue&type=script&lang=js&"
export * from "./UserCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCardText})
